module.exports = "/_next/static/images/bank-permata-icon-f9ea749c915521bc7138038dda7070d3.svg";